import * as yup from 'yup';
import {
  numberRegex,
  specialCharacterRegex,
  uppercaseRegex,
} from '../constant';

const step1Schema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  businessName: yup.string().required('Business name is required'),
  email: yup
    .string().trim()
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      uppercaseRegex,
      'Password must contain at least one uppercase letter',
    )
    .matches(numberRegex, 'Password must contain at least one number')
    .matches(
      specialCharacterRegex,
      'Password must contain at least one special character',
    ),
});

const step2Schema = yup.object().shape({
  mobileNumber: yup.string().required('Phone number is required'),
  countryIso3: yup.string().required('Country is required'),
});

const step3Schema = yup.object().shape({
  accountType: yup.number().required('Account type is required'),
});

const signupValidationSchemas = [step1Schema, step2Schema, step3Schema];

export default signupValidationSchemas;
